import {
    SET_SMTP_ACTIVE_STATUS_START,
    SET_SMTP_ACTIVE_STATUS_SUCCESS,
    SET_SMTP_ACTIVE_STATUS_ERROR
} from '../../../constants';

import {
    getAllSmtpData,
    updateSmtpActiveStatus as updateActiveStatus
} from '../../../lib/graphql';

import showToaster from '../../../helpers/toasterMessages/showToaster';

export function updateSmtpActiveStatus(id) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: SET_SMTP_ACTIVE_STATUS_START
        });
        try {

            const { data } = await client.mutate({
                mutation: updateActiveStatus,
                variables: { id },
                refetchQueries: [{ query: getAllSmtpData }]
            });

            if (data && data.updateSmtpActiveStatus && data.updateSmtpActiveStatus.status == 200) {
                dispatch({
                    type: SET_SMTP_ACTIVE_STATUS_SUCCESS
                });
                showToaster({ messageId: 'smtpActiveStatus', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: SET_SMTP_ACTIVE_STATUS_ERROR
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.updateSmtpActiveStatus?.errorMessage })
            }
        } catch (error) {
            dispatch({
                type: SET_SMTP_ACTIVE_STATUS_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
        }
    }
}